import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { UIHoverActionController } from './UIHoverActionController.ts';
import { PieceTypes } from '@colonist/game-base-types';
import { getCardsForPiece } from '@colonist/game-card-types';
import { TileCornerBuildingType } from '@colonist/game-states';
import { GameStateEnums } from '../../../../../shared/GameEnums.ts';
export class UIKnightUpgradeHoverActionController extends UIHoverActionController {
    onEvent(data, eventType) {
        super.onEvent(data, eventType);
        switch(eventType){
            case GameStateEnums.UIGameEventEnums.KnightStateUpdated:
                this.updateState();
                break;
            default:
                break;
        }
    }
    updateState() {
        const action = this.knightPlayerValidator.canPlayerUpgradeKnight();
        const blockedLocations = this.knightPlayerValidator.whereUpgradeKnightHasNoHigherLevelPieceInSupply();
        this.locationsWithNoHigherLevelPieceInSupply = new Set(blockedLocations);
        var _action_validHoverLocations;
        const upgradeableLocations = (_action_validHoverLocations = action.validHoverLocations) !== null && _action_validHoverLocations !== void 0 ? _action_validHoverLocations : [];
        this.updateHoverLocations([
            ...upgradeableLocations,
            ...blockedLocations
        ], action.canTakeAction);
        this.uiGameManager.mapController.hoverController.onHoverStateChange();
    }
    getConfirmationParameters(locationCornerIndex) {
        const parameters = super.getConfirmationParameters(locationCornerIndex);
        if (this.locationsWithNoHigherLevelPieceInSupply.has(locationCornerIndex)) parameters.canTakeAction = false;
        return parameters;
    }
    getBankActionAmount(locationCornerIndex) {
        const knightAtLocation = this.knightPlayerValidator.getKnightAtLocation(locationCornerIndex);
        if (knightAtLocation === undefined) return undefined;
        return this.knightPlayerValidator.getAmountOfKnightsOfLevelThatCanBePlacedOnMap(knightAtLocation.level + 1);
    }
    getTexture(locationCornerIndex) {
        const knightAtLocation = this.knightPlayerValidator.getKnightAtLocation(locationCornerIndex);
        if (knightAtLocation === undefined) return UIGameSpriteHandler.getKnightForPlayer(this.uiGameManager.gameController.myColor, TileCornerBuildingType.KnightInactiveLevel1);
        const activeState = knightAtLocation.isActivated ? 'Active' : 'Inactive';
        // @ts-expect-error dynamic key
        const knightTexture = TileCornerBuildingType[`Knight${activeState}Level${knightAtLocation.level + 1}`];
        return UIGameSpriteHandler.getKnightForPlayer(this.uiGameManager.gameController.myColor, knightTexture);
    }
    constructor(uiGameManager, knightPlayerValidator){
        super(uiGameManager), this.locationsWithNoHigherLevelPieceInSupply = new Set();
        this.isCornerAction = true;
        this.resources = getCardsForPiece(PieceTypes.Knight);
        this.action = (index)=>this.uiGameManager.socketGameSend.confirmUpgradeKnightSkippingSelection(index);
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this);
        this.knightPlayerValidator = knightPlayerValidator;
    }
}
